import CatalogSection from './components/CatalogSection';
import OrderSummary from './components/OrderSummary';

const CreateOrderPage = () => {
  return (
    <div className="flex h-full bg-[#F8F8FD]">
      {/* Left: Catalog */}
      <div className="flex-1 flex flex-col overflow-hidden border-r border-gray-200 bg-white">
        <CatalogSection />
      </div>

      {/* Right: Order Summary */}
      <div className="w-[380px] flex-shrink-0 overflow-y-auto">
        <OrderSummary />
      </div>
    </div>
  );
};

export default CreateOrderPage;
